import { render, staticRenderFns } from "./tareasExternas.vue?vue&type=template&id=11030b4f"
import script from "./tareasExternas.vue?vue&type=script&lang=js"
export * from "./tareasExternas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports